import { render, staticRenderFns } from "./electricityBillRecords.vue?vue&type=template&id=170c1450&scoped=true&"
import script from "./electricityBillRecords.vue?vue&type=script&lang=js&"
export * from "./electricityBillRecords.vue?vue&type=script&lang=js&"
import style0 from "./electricityBillRecords.vue?vue&type=style&index=0&id=170c1450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c1450",
  null
  
)

export default component.exports